import { atom } from "recoil";

export interface Toast {
  id?: string;
  type?: "SUCCESS" | "FAIL" | "CAUTION" | "";
  content: string;
  duration?: number;
  isSystemToast?: boolean;
  isMobileToast?: boolean;
  isDisplayToast?: boolean;
}

/**
 * 토스트
 */
export const toastState = atom<Toast[]>({
  key: "toastState",
  default: [],
});
